document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.bd-fixture');
    sections.forEach(function(section) {
      // Scope everything inside this section
      const tabs = section.querySelectorAll('.buttons-wrapper button');
      const fixtureBlocks = section.querySelectorAll('.fixture-block');
      const selectElements = section.querySelectorAll('.bd-fixture select.select__select');

      if (tabs && tabs.length > 0){
        tabs[0].classList.add('active');
        const firstTabValue = tabs[0].getAttribute('data-tab');
        section.querySelectorAll(`.fixture-block[data-filter="${firstTabValue}"]`).forEach(block => {
          block.style.display = 'block';
        });
        // Show the correct dropdown for the first tab
        selectElements.forEach(select => {
          select.parentElement.classList.toggle('hidden', select.getAttribute('data-tab') !== firstTabValue);
        });
      }

      // Tab click handler (scoped)
      if(tabs){
        tabs.forEach(function(tab) {
          tab.addEventListener('click', function() {
            const activeTabValue = tab.getAttribute('data-tab');

            // Reset tabs
            tabs.forEach(t => t.classList.remove('active'));
            tab.classList.add('active');

            // Hide all blocks in this section
            fixtureBlocks.forEach(block => block.style.display = 'none');

            // Show blocks for the active tab
            section.querySelectorAll(`.fixture-block[data-filter="${activeTabValue}"]`).forEach(block => {
              block.style.display = 'block';
            });

            // Show/hide the correct dropdowns in this section
            selectElements.forEach(select => {
              const selectTab = select.getAttribute('data-tab');
              select.parentElement.classList.toggle('hidden', selectTab !== activeTabValue);
            });

            // If there's a dropdown for this tab, sync its current value
            const activeSelect = section.querySelector(`.bd-fixture select[data-tab="${activeTabValue}"]`);
            if (activeSelect) {
              const selectedValue = activeSelect.value;

              // Hide everything again and show only the selected filter
              fixtureBlocks.forEach(block => block.style.display = 'none');
              section.querySelectorAll(`.fixture-block[data-filter="${selectedValue}"]`).forEach(block => {
                block.style.display = 'block';
              });
            }
          });
        });
      }

      // Dropdown change handler (scoped)
      selectElements.forEach(function(select) {
        select.addEventListener('change', function() {
          const selectedValue = this.value;

          // Hide all blocks in this sectionth
          fixtureBlocks.forEach(block => block.style.display = 'none');

          // Show only blocks matching the selected value
          section.querySelectorAll(`.fixture-block[data-filter="${selectedValue}"]`).forEach(block => {
            block.style.display = 'block';
          });
        });
      });
    });
  });